import { ACCESSORIES_SUB_TYPES } from "constants/products";
import {
  ACCESSORY_PRODUCT_TYPE,
  FEE_PRODUCT_TYPE,
  HEARING_AID_PRODUCT_TYPE,
  PRODUCT_TYPES,
  SERVICE_PRODUCT_TYPE,
  SUPPLY_PRODUCT_TYPE,
} from "constants/sales";

import { Product } from "services/types/products.type";

export const getProductTypeText = (product: Product) => {
  const {
    master_product: { type, subtype },
  } = product;
  let result = "--";

  if (type === ACCESSORY_PRODUCT_TYPE) {
    result = ACCESSORIES_SUB_TYPES.getFromCode(subtype);
  } else if ([HEARING_AID_PRODUCT_TYPE, SUPPLY_PRODUCT_TYPE].includes(type)) {
    result = PRODUCT_TYPES.getFromCode(type);
  } else if (type === SERVICE_PRODUCT_TYPE) {
    result = "Service";
  } else if (type === FEE_PRODUCT_TYPE) {
    result = "Fee";
  }
  return result;
};

export const isProductEditable = (
  canEdit: boolean,
  isSunoAdminOrBusinessOwner: boolean,
  product_lock?: boolean
) => {
  return canEdit && (!Boolean(product_lock) || isSunoAdminOrBusinessOwner);
};
